import { dataYingxiaotong } from 'dls-icons-data'
import { createIcon } from '../common'

const IconYingxiaotong = /*#__PURE__*/createIcon(dataYingxiaotong)
export default IconYingxiaotong
